<template>
    <div class="community-container">

        <van-pull-refresh
                v-model="isRefresh"
                success-text="Refresh Successfully"
                loading-text="Loading"
                pulling-text="Pull To Refresh"
                loosing-text="Release to refresh"
                @refresh="onRefresh">
            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="No more data"
                    @load="onLoad"
            >


                <div class="community-item" @click="itemClick(item)" v-for="item in data" :key="item.id">
                    <span class="title">{{item.title}}</span>
                    <div v-html="item.content" class="content mt-8"></div>
                    <van-image
                            class="statistics flavor-img"
                            width="100%"
                            height="200px"
                            fit="cover"
                            round
                            :show-error="false"
                            :src="item.frontCover"
                    />
                </div>
            </van-list>
        </van-pull-refresh>

    </div>
</template>

<script>
    import deviceRepository from "../repository/store/DeviceRepository"

    export default {
        name   : "Community",
        data() {
            return {
                data     : [],
                page     : 1,
                loading  : false,
                finished : false,
                isRefresh: false
            }
        },
        methods: {
            onLoad() {
                if (this.$store.state.deviceInfo.podId) {
                    deviceRepository.consultationList(this.$store.state.deviceInfo.podId, this.page).then(data => {
                        if (this.isRefresh) {
                            this.data      = []
                            this.isRefresh = false
                        }
                        this.data.push(...data)
                        this.page++
                        this.loading = false
                        if (data.length < 10) {
                            this.finished = true
                        } else {
                            this.finished = false
                        }
                    })
                }
            },
            onRefresh() {
                this.page     = 1
                this.finished = false
                this.loading  = true
                this.onLoad()
            },
            itemClick(item) {
                if (item.contentType === 0) {
                    this.$router.push({
                        name  : "Web",
                        params: {
                            url  : `https://app.unicoreus.com/html/#/detail?id=${item.id}`,
                            title: item.title
                        }
                    })
                } else {
                    this.$router.push({
                        name  : "Web",
                        params: {
                            url  : item.contentUrl.replace("http://13.57.48.78:8080", `https://${location.hostname}`),
                            title: item.title
                        }
                    })
                }
            }
        },
        activated() {
        }
    }
</script>

<style lang="scss" scoped>
    .community-container {
        display: flex;
        flex-direction: column;

        .community-item {
            margin: 16px;
            display: flex;
            flex-direction: column;

            .title {
                color: #F6F6F6;
                font-weight: bolder;
            }

            .content {
                width: 100%;
                color: #999999;
            }
        }
    }

    .custom-image .van-empty__image {
        width: 90px;
        height: 90px;
    }
</style>